import { render, staticRenderFns } from "./DeptPaperInfo.vue?vue&type=template&id=0c98e322&scoped=true"
import script from "./DeptPaperInfo.vue?vue&type=script&lang=js"
export * from "./DeptPaperInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptPaperInfo.vue?vue&type=style&index=0&id=0c98e322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c98e322",
  null
  
)

export default component.exports